<template>
  <section class="text-module">
    <div class="headline">{{content.intro_headline}}</div>
    <span class="copy">{{content.intro_copy}}</span>
  </section>
</template>


<script>
export default {
  props: {
    content: {
      type: Object
    }
  }
};
</script>